<template lang="pug">
  .component-backoffice-cards.row.column
    card-list-form(@filterCards="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
      header-columns(slot="before", :columns="headers")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import CardListForm from 'components/structure/ui/filters/CardListForm'
  import BaseList from "./BaseList";
  import HeaderColumns from "../../components/structure/ui/HeaderColumns";

  export default {
    name: "CardList",
    components: {
      HeaderColumns,
      BaseList,
      KeplerBackofficeSdk,
      CardListForm
    },
    data: function () {
      return {
        headers: ['Card name & ID', 'Driver', 'Chip id', 'Active', 'id/uid'],
        component: require('components/backoffice/Card'),
        search: null
      }
    },
    methods: {
      setSearch(search) {
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.cards.list(page, resultsPerPage, search).all((data) => {
          callback(data)
        })
      },
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// CardList.vue?2e26a8ca